/**
 * Social Meta Tags Utility
 * Helper functions for generating Open Graph and Twitter Card metadata
 */

const SITE_URL = 'https://www.unisave.my';
const DEFAULT_OG_IMAGE = 'https://www.unisave.my/placeholders/blog-featured.svg'; // Fallback image
const SITE_NAME = 'Unisave';

/**
 * Ensure URL is absolute
 * If URL is relative, prepend SITE_URL
 * If URL is already absolute, return as-is
 */
export const ensureAbsoluteUrl = (url) => {
  if (!url) return DEFAULT_OG_IMAGE;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Remove leading slash if present, then prepend SITE_URL
  const cleanPath = url.startsWith('/') ? url.slice(1) : url;
  return `${SITE_URL}/${cleanPath}`;
};

/**
 * Truncate text to max length, ensuring it doesn't cut words
 */
export const truncateText = (text, maxLength = 160) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  // Find last space before maxLength
  const truncated = text.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  return lastSpace > 0 ? truncated.substring(0, lastSpace) + '...' : truncated + '...';
};

/**
 * Generate default Open Graph meta for homepage
 */
export const getDefaultHomepageMeta = (homepageSettings = {}) => {
  // Default values (admin-controlled defaults)
  const defaultTitle = 'Unisave - Your #1 Higher Education Consultant';
  const defaultDescription = 'Discover top universities, programs, and scholarships. Get expert guidance for your study abroad journey.';
  const defaultImage = DEFAULT_OG_IMAGE;

  return {
    title: defaultTitle,
    description: defaultDescription,
    image: defaultImage,
    url: SITE_URL,
    type: 'website',
    siteName: SITE_NAME,
  };
};
